import { FileImportState } from './reducers';

export const getFileImport = ({ dutyFileImport }) => dutyFileImport as FileImportState;
